import React from "react";

import * as Styled from "./Error.styled";

export const Error: React.FC<{ message: string }> = ({ message }) => {
  return <Styled.ErrorWrapper>{message}</Styled.ErrorWrapper>;
};
